export const RouteName = {
  NewRaffle: 'Nova campanha',
  EditRaffle: 'Editar campanha',
}